import { removeFromLocalStorage } from "../../helpers/Localstorage";
import { WebService } from "./RequestService";
import { useNavigate } from "react-router-dom";

class LogoutService {
  static shared = new LogoutService();
  navigate = null;

  setNavigate(navigate) {
    this.navigate = navigate;
  }

  async logout() {
    try {
      // Clear any pending API requests
      WebService.clientShared.instance.interceptors.request.clear();
      WebService.clientShared.instance.interceptors.response.clear();
      
      // Clear local storage
      removeFromLocalStorage();
      
      // Redirect to login page using React Router
      if (this.navigate) {
        this.navigate('/login', { replace: true });
      } else {
        // Fallback to window.location if navigate is not set
        window.location.href = '/login';
      }
    } catch (error) {
      // Even if there's an error, we should still clear storage and redirect
      removeFromLocalStorage();
      if (this.navigate) {
        this.navigate('/login', { replace: true });
      } else {
        window.location.href = '/login';
      }
    }
  }
}

export default LogoutService; 